/**
 * AVA-475 — the short support reference used to title each point's result table.
 *
 * The AVA-356 reference report titles a point table `ST4044.P01`, not
 * `1HDD06ST4044.P01`: the building and level are already in the report header,
 * so repeating them on every table is noise. The plan states the example but not
 * the rule, so the rule is stated HERE and both consumers (the HTML preview and
 * the PDF builder) share it — a second, silently-different regex in the PDF is
 * how a report and its own preview end up disagreeing.
 *
 * RULE: strip a leading building code, then any digits that immediately follow
 * it (the level/sequence segment). Anything left is the short reference.
 *
 *   supportNo '1HDD06ST4044' + building '1HDD'  ->  'ST4044'
 *
 * FALLS BACK to the full supportNo whenever the rule does not apply — no
 * building given, no prefix match, or nothing left after stripping. A slightly
 * long title is harmless; an empty or wrong one on a conformance document is
 * not. This is deliberately conservative: it only ever shortens a value it can
 * prove it understands.
 */

/**
 * @param {string} supportNo Full support identifier, e.g. '1HDD06ST4044'.
 * @param {string} [building] Building code from the same record, e.g. '1HDD'.
 * @returns {string} Short reference for display, or `supportNo` unchanged.
 */
export function shortSupportRef(supportNo, building) {
  if (typeof supportNo !== 'string' || !supportNo) return '';
  if (typeof building !== 'string' || !building) return supportNo;
  if (!supportNo.startsWith(building)) return supportNo;

  const remainder = supportNo.slice(building.length).replace(/^\d+/, '');
  return remainder || supportNo;
}

export default shortSupportRef;
